import { createDateObject, statuses } from '@/core';
import tripAddress from './tripAddress';
import cargoCarrier from './cargoCarrier';
import vendor from './vendor';
import leg from './leg';

export default function() {
	return {
		id: undefined,
		tripNumber: undefined,
		cargoCarrier: cargoCarrier(),
		etd: createDateObject({ hasTime: false }),
		eta: createDateObject({ hasTime: false }),
		fromAddress: tripAddress(),
		toAddress:  tripAddress(),
		clerk: undefined,
		driver: undefined,
		needAccept: false,
		status: statuses.trip.ready,
		type: {
			key: undefined,
			value: undefined
		},
		volume: 0,
		grossWeight: 0,
		loadingMeters: 0,
		vendor: vendor(),
		viaLocations: [],
		legs: [leg()],
		orders: [],
		deviations: [],
	};
}
